import { useMutation } from '@tanstack/react-query';
// service
import { login } from '../../services/auth/authService';
// store
import { useAppContext } from '../../store/AppContext';

export const useAuth = () => {
  const [, appDispatch] = useAppContext();

  const loginMutation = useMutation(
    login,
    {
      onSuccess: (data) => {
        appDispatch({ type: 'DELETE_AUTHENTICATION' });
        appDispatch({ type: 'SET_AUTHENTICATION', payload: data });
      },
    },
  );

  const logout = () => {
    appDispatch({ type: 'DELETE_AUTHENTICATION' });
  };

  return {
    loginMutation,
    logout,
  };
};
